<template>
  <div class="lead-update-statistics lead-mask gutter-xs">
    <div class="title-grid">
      <h4>{{$t('ui.pages.lead-statistics-overview')}}</h4>
      <router-link :to="{ name: 'project_lead_stats', params: {id: projectId, leadId: leadId} }">
        {{$t('statistics.see_full_statistics')}}
      </router-link>
    </div>
    <div v-if="trackings.length > 0">
      <statistics-overview :start-date="start_date.format()" :end-date="end_date.format()" :trackings="trackings" :stats="stats"></statistics-overview>
    </div>
    <div v-else>
      {{$t('statistics.no_data_7_days')}}
    </div>
  </div>
</template>
<script>
import TrackingTable from "./TrackingTable"
import StatisticsOverview from "@/components/helpers/Specific/StatisticsOverview"
import Gauge from "@/components/helpers/DataDisplay/Gauge"
import RelativeDateChoser from "@/components/helpers/DataInput/RelativeDateChoser"
import Tracking from "@/api/Tracking"
import Lead from "@/api/Lead"
import Permissions from '@/classes/Permission'

export default {
  components: { TrackingTable, Gauge, Tracking, StatisticsOverview, RelativeDateChoser },
  props: ['leadId', 'projectId'],
  data(){
    return {
      trackings: [],
      trackings_24h: [],
      tracking_api: new Tracking(),
      stats: [],
      lead_api: new Lead(),
      start_date: Object,
      end_date: Object
    }
  },
  computed: {
    allowedStatistics() {
      return Permissions.planCan('allowed_statistics')
    }
  },
  mounted(){
    this.newDate(7)
  },
  watch: {
    allowedStatistics() {
      if (this.allowedStatistics) {
        this.retrieve()
      }
    }
  },
  methods: {
    newDate(date){
      this.end_date = moment()
      this.start_date = moment().subtract(date, 'days')
      if (this.allowedStatistics) {
        this.retrieve()
      }
    },
    retrieve(){
      let params = {
        start_date: this.start_date,
        end_date: this.end_date,
        sort_by: 'time',
        sort_order: 'DESC'
      }
      this.tracking_api.all(Object.assign({lead_id: this.leadId},params)).then((items) => {
        this.trackings = items.resources
      })
      this.lead_api.statistics(this.leadId,params).then((item) => {
        this.stats = item
      })
    }
  }
}
</script>
<style lang="scss">
.statictics-overview {
  margin-bottom: 20px;
}

.lead-update-statistics h4{
  font-weight: 400;
  margin: .6em 0;
  color: $onyx;
}
.statistic-card .card--content{
  text-align: center;
}
.statistic-card .number--big{
  font-size: 5em;
  line-height: 1;
}
.statistic-card .number--subtext{
  margin-top: 0;
  font-size: 1.3em;
}
</style>



// WEBPACK FOOTER //
// LeadUpdateStatistics.vue?653140da